import React, { useEffect, useState } from "react";
import "../../../static/styles.css";

const FeatureCard = ({ icon, darkIcon, title, description, link }) => {
  const [currentIcon, setCurrentIcon] = useState(icon);
  const [currentArrowIcon, setCurrentArrowIcon] = useState("/icons/icon-go.svg"); // Default arrow icon

  // Switch icon based on the dark mode class on the <html> element
  useEffect(() => {
    const updateIcon = () => {
      const isDarkMode = document.documentElement.classList.contains("dark");
      setCurrentIcon(isDarkMode ? darkIcon : icon);
      setCurrentArrowIcon(isDarkMode ? "/icons/icon-go-dark.svg" : "/icons/icon-go.svg"); // Change arrow icon
    };

    // Update the icon when the component mounts
    updateIcon();

    // Optional: Handle mode changes dynamically if Hugo toggles dark mode
    const observer = new MutationObserver(updateIcon);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });

    return () => observer.disconnect();
  }, [icon, darkIcon]);

  return (
    <a href={link}>
      <div className="featureCard">
        <div className="featureHeader">
          <div className="featureIcon">
            <img loading="lazy" src={currentIcon} alt={title} />
          </div>
          <h3 className="featureTitle">{title}
          <img
          loading="lazy"
          src={currentArrowIcon}
          alt=""
          className="arrowIcon"
        />
          </h3>
        </div>
        <p className="featureDescription">{description}</p>
      </div>
    </a>
  );
};

const FeatureGrid = () => {
  const features = [
    {
      icon: "/icons/icon-inventory.svg",
      darkIcon: "/icons/icon-inventory-dark.svg",
      title: "Inventory",
      description: "View and manage your resources across your cloud, Kubernetes, and container environments",
      link: "/en/inventory/"
    },
    {
      icon: "/icons/icon-risks.svg",
      darkIcon: "/icons/icon-risks-dark.svg",
      title: "Risk",
      description: "Review findings from Cloud Native Application Protection Platform focal areas, add attack path analysis and prioritize.",
      link: "/en/risks"
    },
    {
      icon: "/icons/icon-threats.svg",
      darkIcon: "/icons/icon-threats-dark.svg",
      title: "Threats",
      description: "Analyze event trends and view at-a-glance summaries of event activity over the past 31 days.",
      link: "/en/threats"
    },
    {
      icon: "/icons/icon-vulnerabilities.svg",
      darkIcon: "/icons/icon-vulnerabilities-dark.svg",
      title: "Vulnerabilities",
      description: "View scan results from your runtime, container registries, and pipelines. Manage vulnerability risks.",
      link: "/en/vulnerabilities"
    },
    {
      icon: "/icons/icon-posture.svg",
      darkIcon: "/icons/icon-posture-dark.svg",
      title: "Compliance",
      description: "Check selected controls from various compliance standards. Compile and report your findings",
      link: "/en/compliance"
    },
    {
      icon: "/icons/icon-identity.svg",
      darkIcon: "/icons/icon-identity-dark.svg",
      title: "Identity",
      description: "Manage cloud infrastructure entitlement. Review and mitigate Permission Criticalities in minutes.",
      link: "/en/identity"
    },
  ];

  return (
    <section className="featureGrid">
      {features.map((feature, index) => (
        <FeatureCard key={index} {...feature} />
      ))}
    </section>
  );
};

export default FeatureGrid;
